import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useLoading } from '../../contexts/LoadingContext';
import apiClient from '../../utils/apiClient';

const QueueJoinHandler = () => {
    const { code } = useParams();
    const navigate = useNavigate();
    const { startLoading, stopLoading } = useLoading();

    useEffect(() => {
        const joinQueue = async () => {
            startLoading();
            try {
                await apiClient.post(`/api/events/queues/${code}/join/`);
            } catch (error) {
                // Even if it fails or user is already in queue, just go to profile
                console.error('Queue join error:', error);
            } finally {
                stopLoading();
                navigate('/profile');
            }
        };

        if (code) {
            joinQueue();
        } else {
            navigate('/profile');
        }
    }, [code, navigate, startLoading, stopLoading]);

    // Return null - the global loading spinner will show
    return null;
};

export default QueueJoinHandler;
